import StorePageHeader from './StorePageHeader';

export default StorePageHeader;
